import { cn } from "@/lib/utils";

interface StageBadgeProps {
  stage: {
    name: string;
    color: string;
  };
  className?: string;
}

export function StageBadge({ stage, className }: StageBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full",
        className,
      )}
      style={{
        backgroundColor: `${stage.color}20`,
        color: stage.color,
        borderColor: `${stage.color}40`,
        borderWidth: "1px",
      }}
    >
      <span
        className="h-2 w-2 rounded-full"
        style={{ backgroundColor: stage.color }}
      />
      {stage.name}
    </span>
  );
}
